import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { IconButton, InputAdornment } from "@material-ui/core";
import TextField from "@material-ui/core/TextField/index";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";

const initialValues = {
  password: "",
  passwordConfirm: "",


};

export default function ChangePassword(props) {
  const token = useSelector((state) => state.auth.token);

  const { onHide, id, show } = props;
  const [isError, setIsError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [values, setValues] = useState({
  password: "",
  passwordConfirm: "",
  showPasswordConfirm: false,
  showPassword: false,
  });
  const handleClickShowPassword = (key) => {
    setValues({ ...values, [key]: !values[key] });
  };
  const PasswordSchema = Yup.object().shape({
    password: Yup.string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_-])(?=.{8,})/,
      "Şifrə uzunluğu 8 olan böyük hərf, kiçik hərf, rəqəm və simvoldan ibarət olmalıdır."
    )
      .required("Şifrə tələb olunur"),
    passwordConfirm: Yup.string()
      .when("password", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          " Hər iki şifrə eyni olmalıdır"
        ),
      })
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_-])(?=.{8,})/,
        "Şifrə uzunluğu 8 olan böyük hərf, kiçik hərf, rəqəm və simvoldan ibarət olmalıdır."
      )
      .required("Şifrənin təsdiqlənməsi tələb olunur"),
  });

  const onChangeUserPassword = (password, resetForm, setSubmitting) => {
    setIsLoading(true);
    axios
      .put(
        `${process.env.REACT_APP_API_URL}user/password/${id}?${
          password ? `&password=${password}` : ""
        }`,
        {
          id,
          password,
        },
        {
          headers: { Authorization: `bearer ${token}` },
        }
      )
      .then(() => {
        resetForm();
        setSubmitting(false);
        onHide(false);
        setIsLoading(false);

      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        setIsLoading(false);

        }
      );
  };

  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };

  const formik = useFormik({
    initialValues,
    validationSchema: PasswordSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onChangeUserPassword(values.password, resetForm, setSubmitting);
    },
  });

  const resetForm = () => {
    onHide();
    formik.resetForm();
  };

  return (
    <Modal
      onHide={resetForm}
      show={show}
      size="sm"
      aria-labelledby="edit"
      centered
      className="modal pr-0"
    >
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="changePassword">Şifrəni dəyiş</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="password"
                    className="w-100"
                    type={values.showPassword ? "text" : "password"}
                    label="Yeni şifrə"
                    value={values.showPassword}
                    error={getInputClasses("password")}
                    {...formik.getFieldProps("password")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            aria-label="Toggle password visibility"
                            onClick={() =>
                              handleClickShowPassword("showNewPassword")
                            }
                          >
                            {values.showPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                {formik.touched.password && formik.errors.password ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.password}
                    </div>
                  </div>
                ) : null}
                </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="passwordConfirm"
                    className="w-100"
                    type={values.showPasswordConfirm ? "text" : "password"}
                    label="Yeni şifrəni təsdiqlə"
                    value={values.confirmPassword}
                    error={getInputClasses("passwordConfirm")}
                    {...formik.getFieldProps("passwordConfirm")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            aria-label="Toggle password visibility"
                            onClick={() =>
                              handleClickShowPassword("showPasswordConfirm")
                            }
                          >
                            {values.showPasswordConfirm ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                {formik.touched.passwordConfirm &&
                formik.errors.passwordConfirm ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.passwordConfirm}
                    </div>
                  </div>
                ) : null}
                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              onHide(false);
              formik.resetForm();
            }}
          >
            Ləğv et
          </Button>
          <Button type="submit" className={isLoading ? "px-9" : ""}>
          <span>Şifrəni dəyiş</span>
          {isLoading && <span className="ml-3 spinner spinner-white"></span>}
        </Button>
         
        </Modal.Footer>
      </form>
    </Modal>
  );
}
